import api from './api';

export function checkPaymentStatus(contentId) {
  return api.get(`/payment/${contentId}/check-status`);
}
